<template>
	<div data-testid="reservation-component">
		<!-- Pending Reservation -->
		<section class="reservation" v-show="!ux.isPrinting" v-if="isLoadingOk && step === 'pending'">
			<header>
				<div class="container p-t-3" data-testid="pendingReservationHeader">
					<div class="row row-xs-baseline">
						<div class="col-xs-12 col-lg-5 col-lg-offset-2">
							<h1 class="h2 m-b-2">
								Pending Reservation
							</h1>
						</div>
						<div class="col-xs-12 col-lg-3 text-lg-right">
							<p class="m-b-2" v-if="ux.expires">
								<ExpireTimer
									title="Time left to complete:"
									:expirationDate="ux.expires"
									:expirationAlert="timerAlert"
									@timer-alert="handleTimerAlert"
									@timer-expired="handleTimerExpired"/>
							</p>
						</div>
					</div>
				</div>
			</header>

			<div class="reservation-body">
				<div class="container">
					<!-- <div class="row p-t-2" v-if="isResource && durations.length > 1">
						<div class="col-xs-12 col-sm-3 col-md-3 col-lg-2 col-lg-offset-2">
							<div class="form-group">
								<label for="duration">
									Start Time
								</label>
								<div class="form-control-static">
									<TemporalDisplay :start="ux.start" template="time"/>
								</div>
							</div>
						</div>
						<div class="col-xs-12 col-sm-3 col-md-3 col-lg-2">
							<div class="form-group form-group-spacer">
								<label v-if="!isWorkExperience" for="duration">
									Duration
								</label>
								<label v-if="isWorkExperience" for="duration">
									End Time
								</label>
								<select v-model="duration" @change="handleDurationChange" id="duration" class="c-select">
									<option v-for="item in durations" :value="item" :key="item.value">
										{{ item.label }}
									</option>
								</select>
								<InlineAlert
									v-if="validationShow"
									:errors="validationResults"
									:types="validationTypes.duration"/>
							</div>
						</div>
					</div> -->

					<div class="row p-t-2">
						<div class="col-xs-12 col-lg-8 col-lg-offset-2">
							<div class="card card-reserved">
								<div class="card-section-top">
									<h2 class="card-title-wrapper">
										<span class="h5">
											{{ ux.resourceType }}
										</span>
										<span class="h3 card-title">
											{{ ux.name }}
										</span>
									</h2>
									<div v-if="ux.priceString">
										<p class="card-price" data-testid="price">
											{{ ux.priceString }}
										</p>
									</div>
									<p class="small m-t-sm">{{ ux.disclaimer }}</p>
									<div class="m-t-2" v-if="isResource && durations.length > 1">
										<label v-if="!isWorkExperience" for="duration" class="h5">
											Duration
										</label>
										<label v-if="isWorkExperience" for="duration">
											End Time
										</label>
										<select v-model="duration" @change="handleDurationChange" id="duration" class="c-select m-t-sm">
											<option v-for="item in durations" :value="item" :key="item.value">
												{{ item.label }}
											</option>
										</select>
										<InlineAlert
											v-if="validationShow"
											:errors="validationResults"
											:types="validationTypes.duration"/>
									</div>
								</div>
								<div class="card-section">
									<div class="card-section-cell">
										<p class="m-b-0">
											<TemporalDisplay :start="ux.start" template="dateFull"/>
										</p>
										<p class="m-b-0">
											<TemporalDisplay :start="ux.start" :end="ux.end" template="time"/>
										</p>
										<p class="m-b-0">
											{{ fullLocation }}
										</p>
										<p class="m-b-0" v-if="ux.instructors.length > 0">
											<strong>With:</strong>
											<span v-html="buildInstructors(ux.instructors)"></span>
										</p>
									</div>
									<div class="card-section-cell" v-if="spots.length === 0 || ux.openSpots === 0">
										<ParticipantSub
											ref="participants"
											:hasSingleParticipant="hasSingleParticipant"
											:hasSpotSelection="spots.length > 0 && ux.openSpots > 0"
											:availableSpots="false"
											:participants="participants"
											:hasRules="specialRequirements.length > 0"
											@updated="handleParticipantUpdated"/>

										<InlineAlert
											v-if="validationShow"
											:errors="validationResults"
											:types="validationTypes.participants"/>
									</div>
								</div>
								<div class="card-section" v-if="spots.length > 0 && ux.openSpots > 0">
									<div class="card-section-cell">
										<ParticipantSub
											ref="participants"
											:hasSingleParticipant="hasSingleParticipant"
											:hasSpotSelection="spots.length > 0 && ux.openSpots > 0"
											:availableSpots="(ux.openSpots - participants.length) > 0"
											:participants="participants"
											:hasRules="specialRequirements.length > 0"
											@updated="handleParticipantUpdated"/>

										<InlineAlert
											v-if="validationShow"
											:errors="validationResults"
											:types="validationTypes.participants"/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="row" v-if="spots.length > 0 && participants.length > 0">
						<div class="col-xs-12 col-lg-8 col-lg-offset-2">
							<PickASpotSub
								ref="pickSpot"
								:spots="spots"
								:layoutAspectRatio="layoutAspectRatio"
								:participants="participants"
								:instructorName="buildInstructors(ux.instructors)"
								@spot-changed="handleSpotChanged"
							/>
							<InlineAlert
								v-if="validationShow"
								:errors="validationResults"
								:types="validationTypes.spot"/>
						</div>
					</div>

					<!-- Waitlist notification -->
					<div class="row">
						<div class="col-xs-12 col-lg-8 col-lg-offset-2">
							<div class="card card-reserved" v-if="hasWaitlist && ux.openSpots === 0">
								<div class="card-section-top">
									<h4>Waitlist</h4>
									This class is currently full. You will be added to the waitlist, and notified if a spot opens up.
								</div>
							</div>
						</div>
					</div>

					<div class="row" v-if="ux.showPolicies">
						<div class="col-xs-12 col-lg-8 col-lg-offset-2">
							<p class="small">
								Reservation, cancellation, and no-show policies vary by class type. <a href="https://my.lifetime.life/policy/guest-and-club-policy.app.html?show=ltGroupFitnessandLifeStudio" class="link-underlined text-nowrap">View policies.</a>
							</p>
						</div>
					</div>

					<div class="row" v-if="ux.waiverContent && waiverDisplay">
						<div class="col-xs-12 col-lg-8 col-lg-offset-2">
							<div class="form-group form-group-spacer">

								<div class="small">
									By clicking “{{ paymentRequired ? 'Continue to Payment' : 'Finish' }}” you agree to our <a role="button" href="#waiverModal" @click="handleModalShow()" @keydown.space="handleModalShow()" class="link-underlined text-nowrap" data-testid="waiverLink">Reservation Agreement and Waiver</a> and payment of reservation fees (if applicable). You acknowledge you are authorized to make this reservation on behalf of any member you select, and you are authorized to charge your Membership’s Monthly Payment Method or any credit card associated with your Membership to pay for any classes, services, or events subject to a fee.
								</div>

								<InlineAlert
									v-if="validationShow"
									:errors="validationResults"
									:types="validationTypes.waiver"/>
							</div>
						</div>
					</div>

					<div class="row" v-if="showRecaptchaV2">
						<div class="col-xs-12 col-lg-8 col-lg-offset-2" :class="{'m-b-1': !showCaptchaRequiredAlert}">
							<div ref="recaptchaV2Container" class="m-b-1"></div>
							<div v-if="showCaptchaRequiredAlert" class="alert alert-danger" role="alert">
								<p>CAPTCHA is required.</p>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-xs-12 col-lg-8 col-lg-offset-2">
							<div class="btn-wrap text-xs-right">
								<button class="btn btn-link btn-block-sm" v-if="!isMobileApp" @click="handleCancelClick()">
									Cancel
								</button>
								<button class="btn btn-primary btn-block-sm" data-testid="finishBtn" @click="handleFinishClick()">
									{{ paymentRequired ? 'Continue to Payment' : 'Finish' }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="container p-t-2" v-if="specialRequirements.length > 0 || (!isResource && ux.phone)">
				<div class="row">
					<div class="col-xs-12 col-lg-8 col-lg-offset-2">
						<p v-if="specialRequirements.length > 0" id="specialRequirements">
							<small v-for="(message, index) in specialRequirements" :key="index">
								<span>{{ message }}</span>
								<a href="#participantSelector" aria-label="Go back to Participants" class="sr-only sr-only-focusable">↩</a>
							</small>
						</p>
						<p v-if="!isResource && ux.phone" class="small">Questions about this reservation? Please call the club at
							<a :href="ux.phone | phoneFilter('telUrl')" :aria-label="ux.phone | phoneFilter('ariaLabel')" class="link-underlined">{{ ux.phone | phoneFilter('display') }}</a>.
						</p>
					</div>
				</div>
			</div>
		</section>

		<!-- Reservation Confirmation -->
		<ConfirmationSub
			v-if="step === 'confirmed'"
			:resData="confirmationData"
			:showPolicies="ux.showPolicies"
			:regTypeName="ux.regType.name"/>

		<!-- Modals -->
		<Modal ref="waiverModal" id="waiverModal" ariaLabelled="reservationWaiverModal" :wideModal="true">
			<template #title>Reservation Agreement and Waiver</template>
			<template #default>
				<div v-html="ux.waiverContent"></div>
			</template>
		</Modal>

		<Modal ref="timerModal" ariaLabelled="reservationTimerModal">
			<template #title>Continue Registration?</template>
			<template #default>
				<span>The time to complete your reservation is running out. Would you like more time to complete your reservation?</span>
			</template>
			<template #footer>
				<div class="timer-modal-footer">
					<div class="timer-modal-timer" v-if="ux.expires">
						<ExpireTimer
							title="Time left to complete:"
							:expirationDate="ux.expires"/>
					</div>
					<div>
						<button type="button" class="btn btn-link" @click="handleTimerModalClick(false)">No</button>
						<button type="button" class="btn btn-primary" @click="handleTimerModalClick(true)">Yes</button>
					</div>
				</div>
			</template>
		</Modal>

		<!-- Loading Spinner -->
		<div role="alert" aria-live="assertive">
			<transition name="fade" appear>
				<div class="spinner-overlay" data-testid="spinner" v-show="isWaiting">
					<p class="sr-only">Content is loading…</p>
					<LoadingSpinner
						v-show="!isMobileAppDarkMode"
					/>
					<LoadingSpinner
						v-show="isMobileAppDarkMode"
						:config="{color: '#ffffff'}"
					/>
				</div>
			</transition>
		</div>

	</div>
</template>

<script>
import { defineComponent } from 'vue';
import moment from 'moment';
import _ from 'lodash';
import { baseComponentMixin } from '@/mixins/baseComponent.mixin';
import { validationMixin } from './mixins/validation.mixin';
import { momentProvider } from '@/services/clock.service';
import { StateService } from '@/services/state.service';
import { ReservationService } from '@/services/reservation.service';
import { AnalyticsService } from '@/services/analytics.service';
import { FrameworkService } from '@/services/framework.service';
import { NotificationService } from '@/services/notification.service';
import { ldClient, keys } from '@/services/launchDarkly.service';
import { Helpers } from '@/common/helpers';

import ExpireTimer from '@/components/schreg-common/ExpireTimer.vue';
import InlineAlert from '@/components/schreg-common/InlineAlert.vue';
import LoadingSpinner from '@/components/schreg-common/LoadingSpinner.vue';
import Modal from '@/components/schreg-common/Modal.vue';
import TemporalDisplay from '@/components/schreg-common/TemporalDisplay.vue';

import ParticipantSub from './sub/ParticipantSub.vue';
import ConfirmationSub from './sub/ConfirmationSub.vue';
import PickASpotSub from './sub/PickASpotSub.vue';
import LzString from 'lz-string';

export default defineComponent({
	name: 'ReservationComponent',
	config: {
		key: 'schreg.reservation',
		devPath: 'reservations',
		exported: true
	},
	components: {
		ExpireTimer,
		InlineAlert,
		LoadingSpinner,
		Modal,
		TemporalDisplay,
		ParticipantSub,
		ConfirmationSub,
		PickASpotSub
	},
	mixins: [
		baseComponentMixin,
		validationMixin
	],
	data() {
		return {
			ux: {
				regId: null,
				regStatus: null,
				eventId: null,
				expires: null,
				isPrinting: false,
				regMode: null,
				regType: null,

				timezone: null,
				start: null,
				end: null,

				name: null,
				disclaimer: null,
				resourceType: null,
				bookingInterval: 30,
				bookingIntervalCost: 0,
				priceString: null,
				cost: 0,
				paymentMode: null,
				location: null,
				phone: null,
				instructors: [],
				description: null, // TODO: add to C#
				whatToBring: null, // TODO: add to C#
				showPolicies: false,

				clubId: 0,
				waiverName: null,
				waiverContent: null,
				waiverIds: [],
				newReservationUrl: null,
				mmsProductId: null,
				openSpots: 0,
				isWaitlisted: false,
				waitlistSpot: null
			},

			participants: [],
			participantsSelected: [],

			waiverAccepted: true,
			waiverDisplay: true,

			isWorkExperience: false,
			isMobileApp: false,
			isMobileAppDarkMode: false,

			hasSingleParticipant: false,
			hasWaitlist: false,
			hasSpots: false,

			durations: [],
			duration: null,
			durationValue: null,
			intervalUnit: 'minute',

			spots: [],
			layoutAspectRatio: 1,
			spotRequested: null,
			spotSelected: null,

			step: 'pending',
			timerAlert: parseInt(import.meta.env.VITE_EXPIRATION_ALERT_SECONDS, 10),
			isExpired: false,

			isCourt: false,

			recaptchaV2SiteKey: import.meta.env.VITE_RECAPTCHA_V2_SITE_KEY,
			recaptchaV3SiteKey: import.meta.env.VITE_RECAPTCHA_V3_SITE_KEY,
			isRecaptchaRequired: false,
			recaptchaToken: null,
			showRecaptchaV2: false,
			showCaptchaRequiredAlert: false
		};
	},
	computed: {
		isResource: function() {
			return this.ux.regMode === 'resource';
		},
		paymentRequired: function() {
			return this.ux.paymentMode === 'upFront';
		},
		validationShow: function() {
			return this.validationResults.length > 0;
		},
		fullLocation: function() {
			let prefix = '';
			if (this.spotSelected) {
				prefix = `Spot ${this.spotSelected}, `;
			} else if (this.ux.isWaitlisted) {
				prefix = this.ux.waitlistSpot ? `Waitlist Spot ${this.ux.waitlistSpot}, ` : 'Waitlist, ';
			}
			return prefix + this.ux.location;
		}
	},
	created() {
		this.isMobileApp = Helpers.isMobileApp();

		if (this.isMobileApp) {
			if (document.getElementsByClassName('main-mylt').length > 0) {
				const mainClassList = document.getElementsByClassName('main-mylt')[0].classList;
				mainClassList.add('mobile-app');
			}

			if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
				this.isMobileAppDarkMode = true;
			}
			window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
				this.isMobileAppDarkMode = event.matches;
			});
		}
	},
	mounted() {
		this.getFrameworkData(this.completeMounting, ['ProfileStore', 'UrlStore']);
	},
	methods: {
		completeMounting() {
			this.isWorkExperience = FrameworkService.isWorkExperience();
			ReservationService.initialize();

			if (!ReservationService.props.regMode) {
				this.mountServerError(true, 'Sorry, there was an unexpected error with your reservation. Please try again.');
				return;
			}

			if (ReservationService.props.editMode) {
				this.waiverDisplay = false;
			}

			if (!this.userAuthenticated) {
				this.mountServerError(
					true,
					`Please <a href="${FrameworkService.globalUrl('loginResource')}">log in</a> to schedule your session.`
				);
				return;
			}
			this.doPostRequest();
		},

		buildInstructors(instructors) {
			return Helpers.buildInstructors(instructors);
		},

		buildUx(data) {
			this.hasSingleParticipant = data.hasSingleParticipant;
			this.hasWaitlist = data.hasWaitlist;
			this.hasSpots = data.hasSpots;

			this.ux.regId = data.regId;
			this.ux.regStatus = data.regStatus;
			this.ux.regMode = data.regMode;
			this.ux.regType = data.registrationType;
			this.ux.eventId = data.eventId;
			this.ux.newReservationUrl = data.registrationType.newReservationUrl;
			this.ux.mmsProductId = data.mmsProductId;
			this.ux.openSpots = data.openSpots;

			this.buildRules(data);

			this.ux.start = moment.parseZone(data.start);
			this.ux.end = moment.parseZone(data.end);
			this.ux.timezone = data.timezone;

			this.ux.clubId = data.clubId;
			this.ux.showPolicies = !this.isResource && ((data.interests?.includes('Group Fitness') ?? false) || (data.interests?.includes('Group Training') ?? false));
			this.ux.interests = data.interests;

			if (this.isResource) {
				this.ux.name = data.resource.name;
				this.ux.resourceType = data.resource.type;
				this.ux.bookingInterval = data.resource.bookingInterval;
				this.ux.bookingIntervalCost = data.resource.bookingIntervalCost;
				this.durations = _.map(data.resource.durations, this.buildDurationOption);
				this.durationValue = moment.duration(this.ux.end.diff(this.ux.start)).asMinutes();
				this.duration = this.durations.find(d => d.value === this.durationValue);
				this.ux.cost = (this.durationValue / this.ux.bookingInterval) * this.ux.bookingIntervalCost;

				this.ux.description = data.description;
				this.ux.whatToBring = data.whatToBring;
			} else {
				this.ux.name = data.eventName;
				this.ux.cost = data.cost; // TODO: account for # of selected participants
			}

			this.ux.disclaimer = data.disclaimer;
			this.ux.location = data.location;
			this.ux.phone = data.phone;
			this.ux.instructors = data.instructors;

			this.ux.priceString = this.ux.cost > 0 ? `$${this.ux.cost.toFixed(2)}` : null;
			this.ux.paymentMode = data.paymentMode;

			if (data.agreement) {
				this.ux.waiverName = data.agreement.agreementName;
				this.ux.waiverContent = data.agreement.content;
				this.ux.waiverIds = [parseInt(data.agreement.agreementId, 10)];
			}

			if (this.hasSingleParticipant && this.ux.openSpots === 0 && this.hasWaitlist) { // Pending step doesn't have waitlistSpot populated
				this.ux.isWaitlisted = true;
			}

			this.participants = data.participants;
			this.spots = data.spots || [];
			this.layoutAspectRatio = data.layoutAspectRatio || 1;
			if (this.hasSpots) {
				this.spotRequested = this.spotSelected = _.map(this.participants, (p) => p.spot).join(' and ');
			}

			if (this.participants.length) {
				const availableParticipant = this.participants.find(p => p.available);
				if (availableParticipant && availableParticipant.expires) this.buildTimerExpiration(availableParticipant.expires);
			}
		},

		buildTimerExpiration(expireDate) {
			if (StateService.isMockData()) {
				//use this to test extending the timer:
				//const alertExpirationSeconds = parseInt(import.meta.env.VITE_EXPIRATION_ALERT_SECONDS, 10) + 10;
				const alertExpirationSeconds = import.meta.env.VITE_EXPIRATION_SECONDS;
				this.ux.expires = momentProvider().add(alertExpirationSeconds,'seconds');
			} else {
				this.ux.expires = moment.parseZone(expireDate);
			}
		},

		buildDurationOption(duration) {
			const option = {
				label: '',
				value: duration
			};
			if (this.isWorkExperience && this.isResource) {
				option.label = this.ux.start.clone().add(duration, this.intervalUnit).format('h:mm A');
			} else {
				const labelUnit = (duration > 1) ? this.intervalUnit+'s' : this.intervalUnit;
				option.label = duration + ' ' + labelUnit;
			}
			return option;
		},

		buildConfirmationData(participants) {
			if (this.ux.isWaitlisted) {
				this.ux.waitlistSpot = participants[0].waitlistSpot;
			}
			return {
				eventId: this.ux.eventId,
				isResource: this.isResource,
				email: '',
				participants: participants,
				resourceType: this.ux.resourceType,
				resourceName: this.ux.name,
				priceString: this.ux.priceString,
				startMoment: this.ux.start,
				endMoment: this.ux.end,
				location: this.ux.location,
				instructors: this.ux.instructors,
				description: this.ux.description,
				whatToBring: this.ux.whatToBring,
				newReservationUrl: this.ux.newReservationUrl,
				mmsProductId: this.ux.mmsProductId,
				isCourt: this.isCourt,
				disclaimer: this.ux.disclaimer
			};
		},

		buildCartData(regData) {
			return {
				clubId: this.ux.clubId,
				registrationId: this.ux.regId,
				reservationType : this.ux.regMode,
				resourceType : this.ux.resourceType,
				resourceName : this.ux.name,
				location : this.fullLocation,
				startMoment : this.ux.start,
				endMoment : this.ux.end,
				unitCost : this.ux.cost,
				participants : regData.participants,
				instructors : regData.instructors,
				eventId:  this.ux.eventId,
				expiresAt : moment.parseZone(regData.participants[0].expires),
				agreementName : this.ux.waiverName
			};
		},

		buildSelectedParticipants() {
			this.participantsSelected = this.$refs.participants.getSelectedData();
		},

		// Event / Click handlers

		handleModalShow() {
			this.$refs.waiverModal.show();
		},

		handleParticipantUpdated() {
			this.buildSelectedParticipants();
		},

		handleDurationChange() {
			this.isWaiting = true;

			if (this.hasSingleParticipant) {
				this.doUpdateAttendee(this.participants[0]);
			} else {
				_.forEach(this.participantsSelected, (participant) => {
					this.doUpdateAttendee(participant);
				});
			}
		},

		handleFinishClick() {
			this.buildSelectedParticipants();
			NotificationService.close(); // Clear any existing notifications (see ESR-2727)
			if (this.validateComplete()) {
				this.doComplete();
			} else {
				this.buildNotificationMessage(false);
			}
		},

		handleTimerExpired() {
			if (this.isExpired === false) {
				this.$refs.timerModal.hide();
				this.isExpired = true;
				this.doCancel('The time to complete your reservation has expired. Please make a new reservation.');
			}
		},

		handleTimerAlert() {
			if (this.isCourt === false) {
				this.$refs.timerModal.show();
			}
		},

		handleTimerModalClick(isExtended) {
			this.$refs.timerModal.hide();
			if (isExtended && !this.isExpired) {
				this.doExtend();
			}
		},

		handleCancelClick() {
			this.doCancel();
		},

		handleSpotChanged(data) {
			this.isWaiting = true;
			_.map(this.participants, (p) => {
				if (p.memberId === data.memberId) {
					p.spot = data.spot;
				}
			});

			this.doUpdateAttendee(_.find(this.participants, (p) => p.memberId === data.memberId))
				.then(() => {
					this.$refs.participants.setSelectedData(this.participants);
				});
		},

		doGetRequest() {
			return ReservationService.getRequest(this.ux.regId)
				.then(response => {
					if (!response.ok) {
						if (response.status === 401) {
							this.mountServerError(
								true,
								`Please <a href="${FrameworkService.globalUrl('loginResource')}">log in</a> to continue your reservation.`
							);
							return null;
						}
						if (response.data && response.data.validation) {
							this.mountServerError(
								response.data.validation.isFatal,
								response.data.validation.notification
							);
						} else {
							this.mountServerError(
								false,
								'Sorry, there was an unexpected error with your reservation. Please try again.'
							);
						}
						return null;
					}
					return response.data;
				});
		},

		doPostRequest() {
			ReservationService.postRequest()
				.then(response => {
					if (!response.ok) {
						if (response.status === 401) {
							this.mountServerError(
								true,
								`Please <a href="${FrameworkService.globalUrl('loginResource')}">log in</a> to continue your reservation.`
							);
							return;
						}
						if (response.data && response.data.validation) {
							if (response.data.validation.notification === 'User is already registered.') {
								this.doCancelRedirect(); // If user is already on the roster (which wouldn't have been known in remembered state), redirect back to the detail page (no notifcation)
							} else if (response.data.validation.isFatal) {
								this.doCancelRedirect(response.data.validation.notification);
							} else {
								this.mountServerError(
									false,
									response.data.validation.notification
								);
							}
						} else {
							this.doCancelRedirect('Sorry, there was an unexpected error with your reservation. Please try again.');
						}
						return;
					}
					this.buildUx(response.data);
					this.isCourt = response.data.registrationType.isCourt;

					ldClient.waitForInitialization().then(async() => {
						const captchaForCourtsFlagOn = ldClient.variation(keys.captchaForCourts, false);
						this.isRecaptchaRequired = captchaForCourtsFlagOn && !this.isMobileApp && this.isCourt;
						this.isLoadingOk = true;
						this.isWaiting = false;

						if (this.isRecaptchaRequired) {
							let recaptchaScript = document.createElement('script');
							recaptchaScript.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.recaptchaV3SiteKey}&badge=inline`;
							document.getElementsByTagName('head')[0].appendChild(recaptchaScript);
						}

					});
				});
		},

		doSetSpotUnavailable(statusCode, validationMessage, spotKey) {
			if (statusCode === 400 && validationMessage.indexOf('spot') > -1) {
				// error with spot selection
				this.$refs.pickSpot.setSpotUnavailable(spotKey);
			}
		},

		doUpdateAttendee(participant) {
			return ReservationService.putAttendee(this.ux.regId, participant.attendeeId, this.duration ? this.duration.value : null, participant.spot)
				.then(response => {
					if (!response.ok) {
						if (response.status === 401) {
							this.mountServerError(
								true,
								`Please <a href="${FrameworkService.globalUrl('loginResource')}">log in</a> to continue your reservation.`
							);
							return;
						}
						if (response.data && response.data.validation) {
							this.mountServerError(
								false,
								response.data.validation.notification
							);
						} else {
							this.mountServerError(
								false,
								'Sorry, there was an unexpected error with your reservation. Please try again.'
							);
						}
						if (this.hasSpots) {
							//TODO::Reset spot if failed
							//this.$refs.pickSpot.setSelectedSpot(this.spotSelected);
							this.doSetSpotUnavailable(response.status, response.data.validation.notification, this.spotRequested);
						}
						if (this.duration) {
							const durationArr = this.durations.map(d => d.value);
							_.remove(durationArr, item => {
								return item === this.duration.value;
							});
							this.durations = _.map(durationArr, this.buildDurationOption);
							this.duration = this.durations.find(d => d.value === this.durationValue);
						}

						return;
					}

					this.durationValue = this.duration ? this.duration.value : null;
					if (this.durationValue) {
						this.ux.end = this.ux.start.clone().add(this.durationValue, 'minutes');
						this.ux.cost = (this.durationValue / this.ux.bookingInterval) * this.ux.bookingIntervalCost;
						this.ux.priceString = this.ux.cost > 0 ? `$${this.ux.cost.toFixed(2)}` : null;
					}

					if (this.hasSpots) {
						this.$refs.pickSpot.setSelectedSpot(participant.spot);
						this.spotSelected = _.map(this.participants, (p) => p.spot).join(' and ');
						if (response.headers.expires && response.headers.expires > 0) this.buildTimerExpiration(response.headers.expires);
					}

					this.isLoadingOk = true;
					this.isWaiting = false;
				});
		},

		doCancel(notificationMessage) {
			this.isWaiting = true;

			if ((this.ux.regStatus !== 'pending' && !this.hasSingleParticipant) || ReservationService.props.editMode) {
				this.doCancelRedirect(notificationMessage);
				return;
			}

			ReservationService.deleteCancel(this.ux.regId).then(() => {
				this.doCancelRedirect(notificationMessage);
			});
		},

		doCancelRedirect(notificationMessage) {
			// When in authoring mode or in mobile app webview, just show notification on this page (not deferred) without redirecting
			if (window.location.pathname.includes('editor.html') || this.isMobileApp) {
				if (notificationMessage) {
					NotificationService.danger(notificationMessage).trigger();
				}
				this.isWaiting = false; // Hide loading indicator
			} else {
				if (notificationMessage) {
					NotificationService.danger(notificationMessage).deferred().trigger();
				}
				window.location.href = ReservationService.getCancelUrl();
			}
		},

		doExtend() {
			this.isWaiting = true;
			ReservationService.putExtend(this.ux.regId)
				.then(response => {
					if (!response.ok) {
						if (response.status === 401) {
							this.mountServerError(
								true,
								`Please <a href="${FrameworkService.globalUrl('loginResource')}">log in</a> to continue your reservation.`
							);
							return;
						}
						if (response.data && response.data.validation) {
							this.mountServerError(
								false,
								response.data.validation.notification
							);
						} else {
							this.mountServerError(
								false,
								'Sorry, there was an unexpected error with your reservation. Please try again.'
							);
						}
						return;
					}
					if (response.headers.expires && response.headers.expires !== 0) this.buildTimerExpiration(response.headers.expires);

					this.isLoadingOk = true;
					this.isWaiting = false;
				});
		},
		onRecaptchaV2Success(token) {
			this.recaptchaToken = token;
		},
		renderRecaptchaV2() {
			this.recaptchaToken = null;

			if (!window.grecaptcha) {
				// eslint-disable-next-line no-console
				console.error('reCAPTCHA script not loaded.');
				return;
			}

			window.grecaptcha.enterprise.render(this.$refs.recaptchaV2Container, {
				sitekey: this.recaptchaV2SiteKey,
				callback: this.onRecaptchaV2Success,
				'expired-callback': () => {
					this.recaptchaToken = null;
				},
				'error-callback': () => {
					this.mountServerError(false, 'CAPTCHA failed to load.');
				}
			});
			this.isWaiting = false;
		},
		async doComplete() {
			this.isWaiting = true;
			this.showCaptchaRequiredAlert = false;

			// Payment required, redirect to cart
			if (this.paymentRequired) {
				this.doGetRequest().then(regData => {
					if (!regData) return;
					this.doCartAndRedirect(regData);
				});
				return;
			}

			if (this.isRecaptchaRequired) {
				if (!this.recaptchaToken) {
					if (this.showRecaptchaV2) {
						this.mountServerError(false, 'CAPTCHA is required. Please try again.');
						this.showCaptchaRequiredAlert = true;
						this.isWaiting = false;
						return;
					} else {
						try {
							this.recaptchaToken = await window.grecaptcha.enterprise.execute(this.recaptchaV3SiteKey, {
								action: 'courts_reservation_complete'
							});
						} catch {
							this.mountServerError(false, 'CAPTCHA failed to load. Please try again.');
							this.isWaiting = false;
							return;
						}
					}
				}

			}

			const recaptchaVersion = this.showRecaptchaV2 ? 'v2' : 'v3';
			const recaptchaSiteKey = this.showRecaptchaV2 ? this.recaptchaV2SiteKey : this.recaptchaV3SiteKey;

			// No payment required, complete reservation
			ReservationService.putComplete(
				this.ux.regId,
				this.ux.waiverIds,
				this.participantsSelected,
				this.recaptchaToken,
				recaptchaSiteKey,
				recaptchaVersion
			).then(response => {
				if (!response.ok) {
					if (response.status === 401) {
						this.mountServerError(
							true,
							`Please <a href="${FrameworkService.globalUrl('loginResource')}">log in</a> to continue your reservation.`
						);
						return;
					}

					// If response score is low show v2 puzzle
					if (response.data && response.data.validation && response.data.validation.requireRecaptchaV2) {
						this.showRecaptchaV2 = true;
						NotificationService.info('Please complete the CAPTCHA.').trigger();
						this.$nextTick(() => {
							this.renderRecaptchaV2();
						});
						return;
					}

					if (response.data && response.data.validation) {
						this.mountServerError(
							false,
							response.data.validation.notification
						);
						if (this.hasSpots) {
							this.$refs.pickSpot.setSelectedSpot();
							this.doSetSpotUnavailable(response.status, response.data.validation.notification, this.spotSelected);
							this.spotSelected = null;
						}
						// TODO: Process server validation
					} else {
						this.mountServerError(
							false,
							'Sorry, there was an unexpected error with your reservation. Please try again.'
						);
					}
					return;
				}

				if (this.hasSingleParticipant && !this.ux.isWaitlisted && this.ux.eventId) {
					// We already have the participant and their data
					this.confirmationData = this.buildConfirmationData(this.participantsSelected);
					_.forEach(this.confirmationData.participants, (participant) => {
						const loggedInMemberId =  FrameworkService.data('profile.memberId');
						const bookingType = participant.memberId === loggedInMemberId ? 'self booked' : 'booked on behalf';
						const regName = this.isResource ? `${this.ux.resourceType} - ${this.ux.name}` : this.ux.name;
						AnalyticsService.registrationAnalytics(this.ux.regId, ReservationService.props.regMode, regName, bookingType, participant.memberId, this.ux.interests.join('|'));
					});
					this.step = 'confirmed';
					window.scrollTo(0, 0);
					this.isWaiting = false;
					return;
				} else {
					this.doGetRequest().then(regData => {
						if (!regData) return;
						this.ux.eventId = regData.eventId;
						this.confirmationData = this.buildConfirmationData(regData.participants);
						_.forEach(this.confirmationData.participants, (participant) => {
							const loggedInMemberId =  FrameworkService.data('profile.memberId');
							const bookingType = participant.memberId === loggedInMemberId ? 'self booked' : 'booked on behalf';
							const regName = this.isResource ? `${this.ux.resourceType} - ${this.ux.name}` : this.ux.name;
							AnalyticsService.registrationAnalytics(this.ux.regId, ReservationService.props.regMode, regName, bookingType, participant.memberId, this.ux.interests.join('|'));
						});
						this.step = 'confirmed';
						window.scrollTo(0, 0);
						this.isWaiting = false;
					});
				}
			});
		},

		doCartAndRedirect(regData) {
			const cartData = this.buildCartData(regData);

			ReservationService.buildCart(cartData).then(({ cartId, isExerpPosCart }) => {
				if (!cartId) {
					this.mountServerError(false, 'Sorry, there was an unexpected error with your reservation. Please try again.');
					return;
				}
				const cartSessionData = {
					cartModule: {
						cart: {
							partyId: Number.parseInt(FrameworkService.data('profile.partyId'), 10),
							salesChannelId: 19,
							esrRegId: cartData.registrationId,
							isExerpPosCart: isExerpPosCart
						}
					}
				};

				let cartSessionString = JSON.stringify(cartSessionData);

				// If we're not doing local development, then we need to compress the string before putting it in sessionStorage.
				if (!Helpers.isDevOrUi()) {
					cartSessionString = LzString.compressToBase64(cartSessionString);
				}

				StateService.setSessionKeyWithoutPrefix('lt-cart', cartSessionString);
				const cartUrl = StateService.getExerpCartSummaryUrl();

				if (Helpers.isDev()) {
					NotificationService.info(`Success! Redirecting to ${cartUrl}`).deferred().trigger();
					this.isWaiting = false;
					this.isServerError = true; // <-- just to hide the UI
					return;
				}

				window.location.href = cartUrl;
			});
		}
	}
});
</script>

<style scoped lang="scss">
@import "@/common/styles/loading.scss";
@import "styles/reservation.scss";
</style>

<style lang="scss">
@import "@/common/styles/mobile-app.scss";
</style>
